// COLORS
export const CONSECUTIVE_NUMBER_REGEX = /[\d|.]+/g;
export const HEX_RGB_REGEX = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;

// TEXT REGEX
export const SPACE_HYPHEN_GLOBAL_REGEX = /[ |-]+/g;
export const URI_FROM_DATASET_NAME_REGEX = /^[a-z|A-Z]+_/; // Finds all letters up to the first "_"
